/* eslint-disable @typescript-eslint/no-explicit-any */
import { isArray, isObject, snakeCase, transform } from 'lodash';

export const snakeize = (obj: any) =>
  transform(obj, (acc: any, value, key, target) => {
    const camelKey = isArray(target) ? key : snakeCase(key.toString());

    acc[camelKey] = isObject(value) ? snakeize(value) : value;
  });
